function useGetter (getterFns) {
  return Object.entries(getterFns).reduce((prev, curr) => {
    prev[curr[0]] = () => curr[1]
    return prev
  }, {})
}

export default useGetter
